import { ResponsiveBar, BarDatum, BarTooltipProps } from "@nivo/bar";
import React from "react";
import { graphPaletteV2, lightGreyText } from "../../../styles";
import {
  ActivityData,
  Engagement,
  EngagementItem,
} from "../../../models/stewardshipModels";
import { transformEngagementData } from "../utils";
import { ENGAGEMENT_TYPES } from "../constants";
import { FlexibleContainer } from "../../../components/containers/styledComponents";
import { CompassParagraph } from "../../../components/common/styledComponents";
import { LegendCircle } from "../../../components/visuals/styledComponents";

const theme = {
  axis: {
    ticks: {
      text: {
        fill: lightGreyText,
        fontSize: 12,
        fontFamily: "Apercu",
      },
    },
  },
  grid: {
    line: {
      stroke: "#d3d3d3",
      strokeWidth: 0.4,
      strokeDasharray: "6 8",
    },
  },
};

const customTooltip = ({
  id,
  color,
  data,
}: BarTooltipProps<BarDatum>): JSX.Element => {
  return (
    <div
      style={{
        background: "white",
        padding: "9px 12px",
        border: "1px solid #ccc",
        borderRadius: "7px",
      }}
    >
      <FlexibleContainer>
        <CompassParagraph bold={true}>Engament Type:</CompassParagraph>
        <LegendCircle color={color} />
        <CompassParagraph>{id}</CompassParagraph>
      </FlexibleContainer>
      <CompassParagraph>
        <strong>Engagements:</strong> {data[id] || 0}
      </CompassParagraph>
    </div>
  );
};

export const MilestoneProgressChart: React.FC<MilestoneProgressBarsProps> = ({
  data,
}): JSX.Element => {
  const chartData: ActivityData[] = transformEngagementData(data);

  return (
    <div style={{ height: "275px", width: "100%" }}>
      <ResponsiveBar
        data={chartData as unknown as BarDatum[]}
        keys={ENGAGEMENT_TYPES.map((item: Engagement) => item.displayValue)}
        indexBy="manager"
        margin={{ top: 50, right: 50, bottom: 60, left: 60 }}
        padding={0.75}
        valueScale={{ type: "linear" }}
        indexScale={{ type: "band", round: true }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 0,
          tickPadding: 5,
          tickRotation: 0,
        }}
        axisLeft={{
          tickSize: 0,
          tickPadding: 5,
          tickRotation: 0,
          legendPosition: "middle",
          tickValues: 5,
          format: (value) => (Math.floor(value) === value ? value : ""),
        }}
        colors={graphPaletteV2}
        theme={theme}
        borderRadius={0}
        borderWidth={0}
        borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
        animate={true}
        enableLabel={false}
        groupMode="stacked"
        tooltip={customTooltip}
      />
    </div>
  );
};

type MilestoneProgressBarsProps = {
  data: EngagementItem[];
};
